import {KeyboardDatePicker} from '@material-ui/pickers';
import moment from 'moment';
import React from 'react';
import {KeyboardDatePickerProps} from '@material-ui/pickers/DatePicker/DatePicker';
import {MaterialUiPickersDate} from '@material-ui/pickers/typings/date';

export const formatToUTC = (dateValue: Date) => moment(dateValue).utc().toDate();

interface WcvDatePickerProps extends KeyboardDatePickerProps {
    onChange: (date: MaterialUiPickersDate | null, value?: string | null) => void;
}

export const WCVDatePicker = (props: WcvDatePickerProps) => {
    const {onChange, ...rest} = props;

    return (
        <KeyboardDatePicker
            margin="normal"
            format="MM/DD/YYYY"
            //onChange={onChange}
            onChange={(date: any) => {
                const newDate = moment(date).utc();
                onChange(newDate, newDate.format('YYYY-MM-DD'));
            }}
            fullWidth
            inputVariant="outlined"
            InputLabelProps={{
                shrink: true,
            }}
            {...rest}
        />
    );
};
